export const updateHeader = ev => {
    return {
        type: 'UPDATEHEADER',
        ev: ev
    }
}

export const updateUrl = ev => {
    return {
        type: 'UPDATEURL',
        ev: ev
    }
}

export const getStepTitel = ev => {
    return {
        type: 'GETSTEPTITEL',
        ev: ev
    }
}

export const setUpdateButtonActiveStepToFalse = () => {
    return {
        type: "SETUPDATEBUTTONACTIVESTEPTOFALSE"
    }
}

export const setUpdateButtonActiveStepToTrue = () => {
    return {
        type: "SETUPDATEBUTTONACTIVESTEPTOTRUE"
    }
}

export const updateBriefkasten = ev => {
    return {
        type: 'UPDATEBRIEFKASTEN',
        ev: ev
    }
}

export const updateMontage = ev => {
    return {
        type: 'UPDATEMONTAGE',
        ev: ev
    }
}

export const updatePforte = ev => {
    return {
        type: 'UPDATEPFORTE',
        ev: ev
    }
}

export const updateCounter = ev => {
    return {
        type: 'UPDATECOUNTER',
        ev: ev
    }
}

export const updateDescriptionField = ev => {
    return {
        type: 'UPDATEDESCRIPTIONFIELD',
        ev: ev
    }
}

export const selectUploadData = ev => {
    return {
        type: 'SELECTUPLOADDATA',
        ev: ev
    }
}

export const deleteUploadData = () => {
    return {
        type: 'DELETEUPLOADDATA'
    }
}

export const selectEditProduct = ev => {
    return {
        type: 'SELECTEDITPRODUCT',
        ev: ev
    }
}

export const hideEditProduct = () => {
    return {
        type: 'HIDEEDITPRODUCT'
    }
}

export const updateImageIndex = ev => {
    return {
        type: 'UPDATEIMAGEINDEX',
        ev: ev
    }
}

export const updateContactData = ev => {
    return {
        type: 'UPDATECONTACTDATA',
        ev: ev
    }
}
